import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

const FormError = ({ error }) => {
  const displayedError = typeof error === 'string' ? error : '';

  if (!displayedError) {
    return null;
  }

  return <p className={cn('text-s', styles.error)}>{displayedError}</p>;
};

export default FormError;
